import React, { useState, useEffect, useMemo } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
import { connect } from "react-redux";
import Stack from "@mui/material/Stack";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { Radio, Paper, Tooltip, Typography } from "@mui/material";
import { useMsal } from "@azure/msal-react";
import StackedBarChart from "../StackedBarChart";
import GroupedBarLineChart from "../GroupedBarLineChart";
import GroupedBarMultipleLineChart from "../GroupedBarMultipleLineChart";
import { useSelector } from "react-redux";
import DoBarChart from "../DoBarChart";
import { COFMockData, RedeployCost } from "../../../../data/mockdata";
import DPBarChart from "../DPBarChart";
import DPGroupedBarLineChart from "../DPGroupedBarLineChart";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import BarChart from "../BarChart";
import DPBarMultiple from "../DPBarMultiple";
import GraphService from "../../../../services/console_services/Graph";
import Loading from "../../Loading";
import { setModuleTabIndex } from "../../../../store/Actions";
import AutoCompleteSearchField from "../AutoCompleteSearchField";
import CustomScrollButton from "../../ReusableComponents/CustomTabScrollButton";
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={1}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((_theme) => ({
  root: {
    flexGrow: 1,
    dispatch: "flex",
    padding: "10px",
  },
  paper: {
    boxShadow: "none !important",
  },
  loader: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "58vh",
    width: "100%",
    position: "relative",
    top: 0,
    left: 0,
  },
  select: {
    borderColor: "transparent",
    borderStyle: "none",
    height: "30px",
    width: "120px",
    borderRadius: "4px !important",
    background: "var(--Neutral-Colors-White, #FFF)",
    fontSize: "14px !important",
    color: "#404041 !important",
    "&.MuiOutlinedInput-root": {
      margin: "0px 17px",
    },
  },
  main: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: "row",
    padding: "0px 10px",
  },
  appBar: {
    padding: "10px",
  },
  tab: {
    background: "#FFF",
    boxShadow:
      "0px 2px 4px 0px rgba(0, 0, 0, 0.10), 0px 4px 12px 0px rgba(0, 0, 0, 0.10)",
    flex: 1,
    minHeight: "30px",
    borderRadius: "8px",
  },
  activeTabs: {
    color: "#FFF",
    textAlign: "center",
    fontFamily: "Poppins, sans-serif",
    fontSize: "13px",
    fontWeight: "500",
    textTransform: "none",
    borderRight: "1px solid #92949747",
    minHeight: "30px",
    border: "1px solid var(--Neutral-Colors-Off-White, #E6E7E8)",
    background: "var(--Nestle_Blue, #0067A1)",
  },
  inActiveTabs: {
    color: "#59595A",
    fontFamily: "Poppins, sans-serif",
    fontSize: "13px",
    textTransform: "none",
    minHeight: "30px",
    opacity: 1,
    border: "1px solid var(--Neutral-Colors-Off-White, #E6E7E8)",
    background: "var(--Neutral-Colors-White, #FFF)",
  },
  indicator: {
    display: "none",
  },
  filter: {
    fontSize: "14px",
    margin: "0px 2px",
    alignSelf: "center",
  },
  dropDownLabel: {
    marginLeft: "1vw",
  },
}));

const GraphViewFg_Salvage = ({
  tabIndex,
  Module,
  Network,
  DC,
  Products,
  Division,
  PL3,
  graphViewTabList,
  date,
  applyFilter,
  role,
  moduleTabIndexChange,
}) => {
  const classes = useStyles();
  const { instance } = useMsal();

  const [topOrBottomValue, setTopOrBottomValue] = useState("Top");
  const [dollarOrDoh, setDollarorDOH] = useState("Dollars");
  // const [countValue, setCountValue] = useState("100000");
  const countValue = "100000";
  const tabValue = useSelector((state) => state?.tabs?.moduleTabIndex);
  const [graphData, setGraphData] = useState([]);
  const [loading, setLoading] = useState(true);
  const activeTab = graphViewTabList.filter(
    (item) => item.index === tabValue,
  )[0].name;
  // const countList = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  const [metricOptions, setMetricOptions] = useState(
    activeTab === "Bias" ? [...networkOptions] : [],
  );
  const [pl3Options, setPL3Options] = useState(
    activeTab === "Bias" ? [...networkOptions] : [],
  );

  // const allData = useSelector((state) => state);
  const [selectedNetwork, setSeletedNetwork] = useState();
  const [selectedMetricOptions, setSelectedMetricOptions] = useState(
    activeTab === "Bias" ? [networkOptions[0]] : [],
  );
  const [selectedDcOptions, setSelectedDcOptions] = useState([]);
  const [selectedPL3Options, setSelectedPL3Options] = useState([]);
  const [isTabChanged, setIsTabChanged] = useState(false);
  // const [isNetworkChanged, setIsNetworkChaged] = useState(false);
  // const [metricName, setMetricName] = useState("Network");
  const metricName = "Network";
  const radioOptions = () => {
    if (activeTab === "Inv.Salvage risk") {
      return ["Network", "Division", "PL3", "MaterialID"];
    }
    if (activeTab === "Potential savings") {
      return ["Network", "Division", "PL3", "MaterialID"];
    }
    // if (activeTab === "Inv.On Hand") {
    //   return ["Network", "Division", "DC"];
    // }
    if (activeTab === "Orders created") {
      return ["Network", "Division", "DC"];
    }
    if (activeTab === "Excep raised") {
      return ["Network", "Division", "DC"];
    }
    if (activeTab === "Cancelled orders") {
      return ["Network", "Division", "DC"];
    }
    if (activeTab === "Order value") {
      return ["Network", "Division", "DC"];
    }
    return [];
  };
  const [selectedRadioValue, setSelectedRadioValue] = useState(
    radioOptions()[0],
  );

  const getGraphData = (params) => {
    setLoading(true);
    GraphService.getGraph(params, instance)
      .then((data) => {
        if (data?.data) {
          setGraphData(data?.data?.data ? data?.data?.data : data?.data);
        }
      })
      .catch((error) => console.error("Error:", error))
      .finally(() => setLoading(false));
  };
  const memoizedParams = useMemo(
    () => ({
      section: Module,
      type:
        graphViewTabList[tabValue]?.value === "Inv.On Hand DOH"
          ? dollarOrDoh === "Dollars"
            ? "Inv.On Hand Dollars"
            : "Inv.On Hand DOH"
          : graphViewTabList[tabValue]?.value,
      name: selectedRadioValue,
      arrangements:
        activeTab === "Outbound Utilization"
          ? topOrBottomValue === "Top"
            ? "Next"
            : topOrBottomValue
          : topOrBottomValue,
      value: "100000",
      X_Axis: selectedRadioValue,
      Level: role,
      filter: {
        RecommendedDC: DC,
        Network:
          activeTab === "Bias"
            ? metricName === "Network"
              ? selectedMetricOptions?.map((data) => data?.value)
              : []
            : // [
              //       "Inv.Salvage risk",
              //       "Potential savings",
              //       "Inv.On Hand",
              //     ]?.includes(activeTab)
              //   ? [selectedNetwork]
              // :
              Network,
        PL3:
          activeTab === "Bias"
            ? metricName === "PL3"
              ? selectedMetricOptions?.map((data) => data?.value)
              : []
            : [
                  "Inv.Salvage risk",
                  "Potential savings",
                  // "Inv.On Hand",
                ]?.includes(activeTab)
              ? selectedPL3Options?.map((data) => data?.value)
              : PL3,
        Division:
          activeTab === "Bias"
            ? metricName === "Division"
              ? selectedMetricOptions?.map((data) => data?.value)
              : []
            : [
                  "Inv.Salvage risk",
                  "Potential savings",
                  // "Inv.On Hand",
                ]?.includes(activeTab)
              ? Division
              : Division,
        Products: Products,
        startDate: date?.[0],
        endDate: date?.[1],
      },
    }),
    [
      Module,
      tabValue,
      selectedRadioValue,
      topOrBottomValue,
      countValue,
      role,
      DC,
      Network,
      PL3,
      Division,
      Products,
      date,
      dollarOrDoh,
      selectedDcOptions,
      selectedPL3Options,
      selectedNetwork,
    ],
  );

  useEffect(() => {
    // Conditional check to avoid unnecessary API calls
    if (
      !memoizedParams.section ||
      !memoizedParams.type ||
      !memoizedParams.name ||
      !memoizedParams.filter.startDate ||
      !memoizedParams.filter.endDate
    ) {
      return;
    }
    getGraphData(memoizedParams);
  }, [memoizedParams, applyFilter]);

  const getMapedDCData = (params) => {
    GraphService.getMapedDataForFGS(params, instance)
      .then((data) => {
        if (data?.data) {
          const divisionData = data?.data[0].Division.map((item) => ({
            entity: "Division",
            value: item,
          }));
          const PL3Data = data?.data[0].ProductLevel3CategoryDescription.map(
            (item) => ({
              entity: "ProductLevel3CategoryDescription",
              value: item,
            }),
          );
          setMetricOptions([...divisionData]);
          setPL3Options([...PL3Data]);

          if (activeTab === "Bias") {
            setSelectedMetricOptions([divisionData[0]]);
          }
        }
      })
      .catch((error) => console.error("Error:", error));
  };

  useEffect(() => {
    if (activeTab) {
      if (!isTabChanged) {
        // setIsNetworkChaged(true);
        console.log("isTabChanged", isTabChanged);
      }
      const params = {
        Network: [selectedNetwork],
      };
      getMapedDCData(params);

      let tempData = {
        network: selectedNetwork,
        dcOptions: [],
      };
      localStorage.setItem(activeTab, JSON.stringify(tempData));
    }
  }, [selectedNetwork]);

  const handleChange = (_event, newValue) => {
    moduleTabIndexChange(newValue);
    setSelectedRadioValue("Network");
    setTopOrBottomValue("Top");
    setSeletedNetwork("AMBIENT");
    setSelectedMetricOptions([]);

    if (activeTab) {
      setIsTabChanged(true);
      // setIsNetworkChaged(false);
    }
  };

  const handleSelectedNetwork = (event) => {
    setSeletedNetwork(event.target.value);
  };

  const handleRadioChange = (selectedFilter) => {
    setSelectedRadioValue(selectedFilter);
  };

  // const handleTopBottomChange = (event) => {
  //     setTopOrBottomValue(event.target.value);
  // };
  const handleDollarOrDoh = (event) => {
    setDollarorDOH(event.target.value);
  };

  const renderChart = () => {
    return (
      <DPGroupedBarLineChart
        graphData={graphData}
        showAnnotation={false}
        activeTab={activeTab}
        dollarOrDoh={dollarOrDoh}
        module={"FGS"}
      />
    );
  };

  const networkOptions = [
    { entity: "Network", value: "AMBIENT" },
    { entity: "Network", value: "CHILLED" },
    { entity: "Network", value: "FROZEN" },
    { entity: "Network", value: "NPW" },
  ];

  return (
    <Paper elevation={0} className={classes.paper}>
      {loading ? (
        <div className={classes.loader}>
          <Loading />
        </div>
      ) : (
        <>
          {/* <div className={classes.main}>
                        <div className={classes.appBar}> */}
          <Box
            sx={{
              maxWidth: "70vw",
              overflow: "hidden",
            }}
          >
            <Tabs
              value={tabValue}
              onChange={handleChange}
              className={classes.tab}
              aria-label="simple tabs example"
              variant="scrollable"
              scrollButtons="auto"
              ScrollButtonComponent={CustomScrollButton}
              classes={{ indicator: classes.indicator }}
            >
              {graphViewTabList.map((item, index) => (
                <Tab
                  key={index}
                  className={
                    tabValue === index
                      ? classes.activeTabs
                      : classes.inActiveTabs
                  }
                  label={item.name}
                  style={{
                    minHeight: "35px",
                  }}
                  {...a11yProps(index)}
                />
              ))}
            </Tabs>
          </Box>
          {/* //     </div>
                    // </div> */}
          {graphViewTabList.map((_item, index) => (
            <TabPanel key={index} value={tabIndex} index={index}>
              <Stack
                direction="row"
                alignItems="center"
                sx={{ padding: "22px 8px" }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    rowGap: "20px",
                  }}
                >
                  {/* ------------------- */}
                  {/* {
                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        rowGap: "20px",
                      }}
                    >
                      <div style={{ alignSelf: "flex-end" }}>
                        <Select
                          value={selectedNetwork}
                          onChange={handleSelectedNetwork}
                          className={classes.select}
                          displayEmpty
                          inputProps={{ "aria-label": "Without label" }}
                          sx={{ ...classes.select }}
                        >
                          {networkOptions?.map((option) => {
                            return (
                              <MenuItem value={option?.value}>
                                {option?.value}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </div>
                      <div>
                        <Typography
                          sx={{
                            fontSize: "12px",
                            fontWeight: 500,
                            color: "#aaaaaaff",
                            mb: "4px",
                          }}
                        >
                          Select Division
                        </Typography>
                        <AutoCompleteSearchField
                          initialValue={metricOptions[0]}
                          selectedMetricOptions={selectedDcOptions}
                          setSelectedMetricOptions={setSelectedDcOptions}
                          metricOptions={metricOptions}
                          style={{ width: "265px", alignSelf: "flex-end" }}
                        />
                      </div>
                      <div style={{ marginLeft: "18px" }}>
                        <Typography
                          sx={{
                            fontSize: "12px",
                            fontWeight: 500,
                            color: "#aaaaaaff",
                            mb: "4px",
                          }}
                        >
                          Select PL3
                        </Typography>
                        <AutoCompleteSearchField
                          initialValue={pl3Options[0]}
                          selectedMetricOptions={selectedPL3Options}
                          setSelectedMetricOptions={setSelectedPL3Options}
                          metricOptions={pl3Options}
                          style={{ width: "265px", alignSelf: "flex-end" }}
                        />
                      </div>
                    </div>
                  } */}

                  {/* ------------------------------ */}

                  <div style={{ display: "flex", marginLeft: "9px" }}>
                    {radioOptions().map((option) => (
                      <React.Fragment key={option}>
                        <Radio
                          value={option}
                          checked={selectedRadioValue === option}
                          onChange={() => handleRadioChange(option)}
                          size="small"
                          inputProps={{ "aria-label": option }}
                          sx={{
                            color: "#359DD0 !important",
                            "&.Mui-checked": {
                              color: "#359DD0 !important",
                            },
                          }}
                        />
                        <span
                          className={classes.filter}
                          style={{
                            color:
                              selectedRadioValue ===
                              (Module === "SNO" ? "Overall" : "Network")
                                ? "#359DD0"
                                : "#359DD0",
                          }}
                        >
                          {option}
                        </span>
                      </React.Fragment>
                    ))}
                  </div>
                  {/* {activeTab === "Inv.On Hand" && (
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <Typography
                        sx={{
                          fontSize: "12px",
                          fontWeight: 500,
                          color: "#aaaaaaff",
                          mb: "4px",
                          marginLeft: "18px",
                        }}
                      >
                        Units
                      </Typography>
                      <Select
                        value={dollarOrDoh}
                        onChange={handleDollarOrDoh}
                        className={classes.select}
                        displayEmpty
                        inputProps={{ "aria-label": "Without label" }}
                        sx={classes.select}
                      >
                        <MenuItem value="Dollars">Dollars</MenuItem>
                        <MenuItem value={"DOH"}>DOH</MenuItem>
                      </Select>
                    </div>
                  )} */}
                </div>
              </Stack>
              {renderChart()}
            </TabPanel>
          ))}
        </>
      )}
    </Paper>
  );
};

GraphViewFg_Salvage.propTypes = {
  tabIndex: PropTypes.number.isRequired,
  tabChange: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  tabIndex: state.tabs.index,
  Network: state.filter.Network,
  DC: state.filter.DC,
  Products: state.filter.Products,
  PL3: state.filter.PL3,
  date: state.filter.dateRangeFGS,
  Division: state.filter.Division,
  applyFilter: state.filter.applyFilter,
  role: state.login.role,
});

const mapDispatchToProps = (dispatch) => ({
  tabChange: (newValue) => dispatch({ type: "TAB_INDEX", payload: newValue }),
  moduleTabIndexChange: (newValue) =>
    dispatch({ type: "MODULE_TAB_INDEX", payload: newValue }),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(GraphViewFg_Salvage);
